import React from "react";
import ContentBlock from "../../components/ContentBlock/ContentBlock";
import Images from "../../asset/images";
import styles from "./AboutSection.module.scss";
import classNames from "classnames/bind";
import useTranslations from "../../hooks/useTranslations"
const cx = classNames.bind(styles);

function AboutSection() {
  const currentTranslations = useTranslations()
  const contenBlocks = [
    {
      title: "CHAPTER OF SPARKLES",
      side: "right",
      textbtn: currentTranslations?.orther?.read_more,
      srcImage: Images.aboutSection1Image,
      theme: "brown",
      buttonProps: {
        primary: true,
      },
      description: "Like sunlight dancing on water or dew clinging to a leaf at dawn ,each piece in this collection echoes a moment lived, a lesson learned.\nLife is made of chapters, and nature reminds us: the most beautiful sparkles come after the storm.\nWear them as a quiet celebration of your journey.",
      direction: "vertical"

    },
    {
      title: "Gifts of the season",
      side: "left",
      textbtn: currentTranslations?.orther?.shop_gifts,
      theme: "light",
      srcImage: Images.giftAboutImage,
      buttonProps: {
        primary: false,
        second: true,
        to: "/gifts"
      },
      description: null,
      direction: "vertical"

    },
    {
      title: "What were we made for?",
      side: "right",
      textbtn: currentTranslations?.orther?.about_us,
      theme: "brown",
      srcImage: Images.anh3Image,
      buttonProps: {
        primary: true,
        to: "/about-us"
      },
      description: `We were made to celebrate the moments that matter to you, the quiet victories, the heartfelt milestones, and the beauty of simply being yourself. Each piece from Lianne Jewelry is crafted to reflect your unique journey, your style, and the story only you can tell.`,
      direction: "direction"

    },
  ];
  console.log("contenBlocks", contenBlocks)
  return (
    <div className={cx("container-aboutSection")}>
      {contenBlocks.map((item, index) => (
        <ContentBlock
          key={index}
          title={item.title}
          contentSide={item.side}
          theme={item.theme}
          textbtn={item.textbtn}
          srcImage={item.srcImage}
          buttonProps={item.buttonProps}
          description={item.description}
        />
      ))}
    </div>
  );
}

export default AboutSection;

